export enum KeyStatus {
    activee = 'ACTIVEE',
    non_activee = 'NON_ACTIVEE',
    desactivee = 'DESACTIVEE'
}